import { render, staticRenderFns } from "./image-hover.vue?vue&type=template&id=31b88198&scoped=true&"
import script from "./image-hover.vue?vue&type=script&lang=js&"
export * from "./image-hover.vue?vue&type=script&lang=js&"
import style0 from "./image-hover.vue?vue&type=style&index=0&id=31b88198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b88198",
  null
  
)

export default component.exports